<template>
	<div class="no-bottom-margin">
		<BaseSelect :filter-only="true" :options="perPageOptions" v-model="model" />
	</div>
</template>
<script>
import BaseSelect from '@/components/forms/inputs/BaseSelect';

export default {
	name: 'PaginationSizeSelect',
	components: { BaseSelect },
	props: {
		value: {},
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
	data() {
		return {
			perPageOptions: [
				{ display: '10', value: 10 },
				{ display: '25', value: 25 },
				{ display: '50', value: 50 },
				{ display: '100', value: 100 },
			],
		};
	},
};
</script>

<style scoped></style>
